// extracted by mini-css-extract-plugin
export var container = "_sy-0";
export var inputWidth = "_sy-1";